import { Link } from "react-router";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import searchImage from "../../../common/images/search.svg";
import { InputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { useGetEstablishmentsQuery } from "../../../common/api/establishment";
import { useEmployeeId } from "../../../common/utils/useEmployeeId";
import Skeleton from "react-loading-skeleton";
import { setSearchTerm } from "../EstablishmentsSlice";
import { useAppDispatch } from "../../../app/hooks";
import { debounce } from "../../../common/utils/debounce";
import { JSX } from "react";

export const EstablishmentsHeader = (): JSX.Element | null => {
    const dispatch = useAppDispatch();
    const { data: establishmentsData, isLoading: establishmentDataIsLoading } =
        useGetEstablishmentsQuery({
            items_per_page: 9999,
            filter: {
                employee_id: useEmployeeId(),
            },
        });

    if (establishmentDataIsLoading) {
        return <Skeleton height={"5rem"} count={2} borderRadius={"1.5rem"} />;
    }

    if (!establishmentsData) {
        return null;
    }

    return (
        <div className="p-establishments__header">
            <div className="c-breadcrumbs">
                <span>
                    Dashboards / <Link to={RouteEnum.DASHBOARD}>LMS</Link> /
                    Vestiging / Vestigingen
                </span>
            </div>
            <div className="c-header-search">
                <div className="c-header-search__title">
                    <h2>Vestigingen ({establishmentsData.meta?.total})</h2>
                </div>
                <div className="c-header-search__search">
                    <InputField
                        placeHolder={"Zoeken..."}
                        iconRight={searchImage}
                        onChange={debounce((value: string) =>
                            dispatch(setSearchTerm(value)),
                        )}
                    />
                </div>
            </div>
        </div>
    );
};
